import { render, staticRenderFns } from "./DataViewSidebarFormation.vue?vue&type=template&id=81763526&scoped=true&"
import script from "./DataViewSidebarFormation.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarFormation.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarFormation.vue?vue&type=style&index=0&id=81763526&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81763526",
  null
  
)

export default component.exports